import { useEffect, useState } from 'react'
import client from '@/store/client'
import { SVGPureIcon } from '@/ui'
import store from './store'
import { McpServerInstallStatus } from "@shared/constants/mcp"
import { observer } from 'mobx-react-lite'

export const shouldInstallMcp = async(agentId) => {
  return await store.shouldInstall(agentId)
}
export const InstallMcpComponent = observer(() => {
  useEffect(() => {
    return () => {
      store.confirmModal?.destroy?.();
    }
  }, [])
  if (!store.show) return null
  return (
    <>
      <div>
        <div className="font-600 text-black leading-26px mb-16px">
          技能安装中...
        </div>
        <div>
          {
            store.list.map(server => {
              return (
                <div
                  key={server.server_name}
                  className='flex flex-row items-center font-400 text-14px leading-20px text-black mb-16px pl-8px'
                >
                  {
                    server.status === McpServerInstallStatus.installed && <SVGPureIcon size={16} color="#000" name="icon_complete" className='fade-in' />
                  }
                  {
                    server.status === McpServerInstallStatus.unInstalled && <div className='rotate-ele'><img src="https://p1.ssl.qhimg.com/d/inn/8ea475776b25/nm_ag_icon_loading.png" className='size-16px' alt="" /></div>
                  }
                  {
                    server.status === McpServerInstallStatus.failed && <SVGPureIcon size={16} color="#FF3B30" name="mcp_error" className='fade-in' />
                  }
                  <span className='ml-6px'>
                    {server.display_name || server.server_name}
                  </span>
                  { server.status < McpServerInstallStatus.installed && <span className='ml-12px text-black opacity-50'>安装中...</span> }
                  { server.status === McpServerInstallStatus.failed && !(client.isLLQ || client.isSeLLQ) && <span className='ml-12px text-black opacity-50'>此MCP不支持在网页端使用</span> }
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  )
})
